import type { TOC } from '@ember/component/template-only';
import { array, concat } from '@ember/helper';
import t from 'ember-intl/helpers/t';
import type ForcJournalEventBasedComponent from 'parog-web/components/forc/abstract/journal-event-based-component';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
    forcComponent: ForcJournalEventBasedComponent;
  };
}
export default <template>
  {{#if @forcComponent.changeset.hasFistulas}}
    <@form.FieldsRadioGroup
      @propertyName='fistulasFlow'
      @title={{t 'mici-form.fistulasFlow.long' htmlSafe=true}}
      as |Group|
    >
      {{#each (array '0' '1' '2' '3' '4') as |value|}}
        <Group.FieldRadio
          @value={{value}}
          @label={{t (concat 'mici-form.fistulasFlow.answers.' value)}}
        />
      {{/each}}
    </@form.FieldsRadioGroup>
  {{/if}}
</template> satisfies TOC<Signature>;
